import { useDeleteWaitingRoomMutation } from '@/core/services/waiting-room'
import { getApiErrorMessage } from '@/utils/errors'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export function useDeleteWaitingRoom(waitingRoomId: string) {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [deleteConfirmationDialogOpen, setDeleteConfirmationDialogOpen] = useState(false)

  const [deleteWaitingRoom, { isLoading: isDeleting }] = useDeleteWaitingRoomMutation()

  const handleDeleteWaitingRoom = async () => {
    if (!waitingRoomId) return

    try {
      await deleteWaitingRoom(waitingRoomId).unwrap()
      setDeleteConfirmationDialogOpen(false)
      navigate('/waiting-rooms')
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error, t('notification.waitingRoom.delete.error')), { variant: 'error' })
    }
  }

  return {
    deleteConfirmationDialogOpen,
    setDeleteConfirmationDialogOpen,
    isDeleting,
    handleDeleteWaitingRoom,
  }
}
